import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import CRMApi from '../../../../Api/CRM/CRMApi';
import GetLootboxPoolResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxPoolResponse';
import { formatDateStringWithTimezone } from '../../../../utils/formatters';
import BooleanIcon from '../../../elements/booleanIcon';
import useOnce from '../../../hooks/useOnce';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

export default function LootboxPoolDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [lootboxPool, setLootboxPool] = useState<GetLootboxPoolResponse>({} as GetLootboxPoolResponse);
    useOnce(() => CRMApi.lootboxPools.getById(parseInt(id)).then(setLootboxPool));

    return (
        <Card title="Lootbox Pool details">
            <TableDetailsBody>
                <Row label="ID">{lootboxPool.id}</Row>
                <Row label="Lootbox id">{lootboxPool.lootbox_id}</Row>
                <Row label="Is Open">
                    <BooleanIcon value={lootboxPool.is_open} />
                </Row>
                <Row label="Trng hash">{lootboxPool.trng_hash}</Row>
                <Row label="Pool count (left/total)">{`${lootboxPool.items_left_count} / ${lootboxPool.items_count}`}</Row>
                <Row label="Closed at">{formatDateStringWithTimezone(lootboxPool.closed_at)}</Row>
                <Row label="Created at">{formatDateStringWithTimezone(lootboxPool.created_at)}</Row>
            </TableDetailsBody>
        </Card>
    );
}
